import { useState, useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { graphRequest } from 'authConfig';

export function useProfilePhoto(): string | null {
  const { instance, accounts } = useMsal();
  const [photoUrl, setPhotoUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!accounts[0]) return;

    let revoked = false;

    (async () => {
      try {
        let tokenResponse;
        try {
          tokenResponse = await instance.acquireTokenSilent({
            ...graphRequest,
            account: accounts[0],
          });
        } catch (silentError) {
          if (silentError instanceof InteractionRequiredAuthError) {
            tokenResponse = await instance.acquireTokenPopup(graphRequest);
          } else {
            console.warn('[ProfilePhoto] Silent token acquisition failed:', silentError);
            return;
          }
        }

        const response = await fetch(
          'https://graph.microsoft.com/v1.0/me/photo/$value',
          { headers: { Authorization: `Bearer ${tokenResponse.accessToken}` } }
        );

        if (!response.ok) {
          console.warn('[ProfilePhoto] Graph API returned', response.status);
          return;
        }

        const blob = await response.blob();
        if (!revoked) {
          setPhotoUrl(URL.createObjectURL(blob));
        }
      } catch (err) {
        console.warn('[ProfilePhoto] Failed to fetch profile photo:', err);
      }
    })();

    return () => {
      revoked = true;
      setPhotoUrl((prev) => {
        if (prev) URL.revokeObjectURL(prev);
        return null;
      });
    };
  }, [instance, accounts]);

  return photoUrl;
}
